import * as React from 'react';
import '../css/programming-lockup.sass';
import shouldFlipBG from '../utils/should-flip-bg';

export interface ProgramDetail {
  pkgImgUrl: string;
  pkgName: string;
  showName?: string;
}

interface ProgrammingLockupProps {
  details: ProgramDetail[];
  theme?: 'night' | 'day';
  setRef?: any;
  transparent?: boolean;
}

interface ProgrammingLockupState {
  flipBg: string;
}

export default function ProgrammingLockup(props: ProgrammingLockupProps) {
  const { theme = 'day' } = props;
  const inputEl: any = React.useRef(null);
  const [state, setState] = React.useState<ProgrammingLockupState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputEl, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
    if (props.setRef !== undefined) {
      props.setRef(inputEl);
    }
  }, []);

  return (
    <>
      <div
        ref={inputEl}
        className={`program-lockup ${state.flipBg} ${theme}${
          props.transparent ? ' transparent' : ''
        }`}
      >
        {props.details.map((detail: ProgramDetail) => {
          return (
            <div className="program" key={detail.pkgName}>
              <div className="program-img">
                <img
                  alt={detail.pkgName}
                  className="img"
                  src={detail.pkgImgUrl}
                />
              </div>
              <div className="program-info">
                {detail.showName && (
                  <span className="title">{detail.showName}</span>
                )}
                <span className="name">
                  {detail.showName ? ' on ' : ''}
                  {detail.pkgName}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
